import { useState } from "react";
import { endOfDay, startOfDay } from "date-fns";
import { useAppSelector } from "@/redux/features/hooks";
import { useGetStockAdjustmentsQuery } from "@/redux/services/inventory/stockAdjustment.api";
import AdjustmentFilters, {
  AdjustmentFiltersValue,
} from "@/components/inventory/adjustments/AdjustmentFilters";
import AdjustmentHistoryTable from "@/components/inventory/adjustments/AdjustmentHistoryTable";
import AdjustmentDetailsDrawer from "@/components/inventory/adjustments/AdjustmentDetailsDrawer";
import { usePagination } from "@/lib/hooks";

const AdjustmentsPage = () => {
  const restaurant = useAppSelector((state) => state.user.currentRestaurant);
  const { page, limit, onChange } = usePagination(25);
  const [filters, setFilters] = useState<AdjustmentFiltersValue>(() => {
    const now = new Date();
    return {
      from: startOfDay(now).toISOString(),
      to: endOfDay(now).toISOString(),
    };
  });
  const [sortDirection, setSortDirection] = useState<"asc" | "desc">("desc");
  const [drawerId, setDrawerId] = useState<string | null>(null);

  const { data, isFetching } = useGetStockAdjustmentsQuery(
    {
      query: { page, limit, sortDirection, ...filters },
    },
    { skip: !restaurant }
  );

  if (!restaurant) return null;

  const onFiltersChange = (next: AdjustmentFiltersValue) => {
    setFilters(next);
    onChange(limit, 1);
  };

  return (
    <div className="space-y-4">
      <AdjustmentFilters
        restaurantId={restaurant.id}
        value={filters}
        onChange={onFiltersChange}
      />

      <AdjustmentHistoryTable
        adjustments={data?.results ?? []}
        isLoading={isFetching}
        totalCount={data?.count ?? 0}
        currentPage={page}
        pageSize={limit}
        sortDirection={sortDirection}
        onSortDirectionChange={(dir) => {
          setSortDirection(dir);
          onChange(limit, 1);
        }}
        onPageChange={(p) => onChange(limit, p)}
        onPageSizeChange={(size) => onChange(size, 1)}
        onRowClick={(id) => setDrawerId(id)}
      />

      <AdjustmentDetailsDrawer
        isOpen={!!drawerId}
        onClose={() => setDrawerId(null)}
        adjustmentId={drawerId}
      />
    </div>
  );
};

export default AdjustmentsPage;
